import { Component } from '@angular/core';
import { AuthService } from './Services/auth.service';

@Component({
    selector: 'core',
    template: '<router-outlet></router-outlet>'
})

export class CoreComponent {}

@Component({ selector: 'callback', template: '' })

export class CallbackComponent {
    constructor(private _auth: AuthService) {
        // Process access_token within callback url.
        this._auth.handleAuthentication();
    }
}